import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Swipeable } from 'react-swipeable';
import { Rating } from 'audamatic-ui';
import Icon from '../../base_svg-icon/component';
import './styles/styles.scss';

/**
 * ProductQuotes component
 *
 */
class ProductQuotes extends PureComponent {
  constructor(props) {
    super(props);
    const { quotes = [] } = props;
    const currentIndex = quotes.length > 2 ? 1 : 0;
    const currentItem = quotes[currentIndex];

    const initialCurrentID = currentItem.author.toLowerCase()
      .replace(/[^A-Za-z0-9]/g, '');

    this.state = {
      current: initialCurrentID,
      transition: true,
      visibleQuotes: [],
      missingLogos: [],
    };
  }

  componentDidMount() {
    this.setState({
      visibleQuotes: [...this.quotes.slice(0, 3)],
    });
  }

  /*
   * Creates additional fields based on the delivered data
   * @param quotes
   * @return {*[]}
   */
  createExtendedQuotes = (quotes) => {
    if (quotes.length > 0) {
      return [...quotes.map((val) => {
        const value = val;
        value.id = val.author.toLowerCase().replace(/[^A-Za-z0-9]/g, '');
        value.logo = this.assignLogo(value.id);
        value.current = this.state.current;
        return value;
      })];
    }
  };

  setTransition = () => {
    this.setState({
      transition: false,
    }, () => {
      setTimeout(() => {
        this.setState(prevState => ({ transition: true }));
      }, 1);
    });
  };

  get quotes() {
    return this.createExtendedQuotes(this.props.quotes) || [];
  }

  swipeTo = (index) => {
    return () => {
      const quote = this.quotes[index] || {};
      this.setVisibleQuotes(quote.id)();
      this.setTransition();
    };
  };

  get indexes() {
    const { current } = this.state;
    const currentIndex = this.quotes.findIndex(item => item.id === current);
    return {
      currentIndex,
      nextIndex: ((currentIndex + 1) > (this.quotes.length - 1)) ? 0 : currentIndex + 1,
      previousIndex: ((currentIndex - 1) < 0) ? (this.quotes.length - 1) : currentIndex - 1,
    };
  }

  // set the sibling quotes from active. these should be the next and prev items
  setVisibleQuotes = (current) => {
    return () => {
      if (this.state.current === current || this.quotes.length === 1) {
        return;
      }
      if (this.quotes.length < 3) {
        this.setState({
          current,
        });
        return;
      }

      const currentIndex = this.quotes.findIndex((item => item.id === current));

      const lastIndex = this.quotes.length - 1;
      let next = currentIndex + 1;
      let prev = currentIndex - 1;

      if (currentIndex === lastIndex) {
        next = 0;
      }
      if (currentIndex === 0) {
        prev = lastIndex;
      }

      const newItemsToGet = [prev, currentIndex, next];
      const newItems = newItemsToGet.map((val) => {
        const item = this.quotes[val];
        item.current = (item.id === current);
        return item;
      });

      this.setState({
        current,
      }, () => {
        if (this.quotes.length >= 3) {
          this.setState({
            visibleQuotes: newItems,
          }, () => {
            this.setTransition();
          });
        }
      });
    };
  };

  assignLogo(author) {
    const imgConf = {
      baseURL: 'https://www.bruna.nl/images/newsletter/',
      prefix: 'Logo-',
      ext: '.png',
    };
    const imgFileName = imgConf.prefix + author.toLowerCase();
    return imgConf.baseURL + imgFileName + imgConf.ext;
  }

  handleMissingLogo = (id) => {
    const { missingLogos } = this.state;
    return () => {
      // we already know this logo is missing. no need to set in in the state again.
      if (missingLogos.includes(id)) {
        return;
      }

      this.setState(prevState => ({
        missingLogos: [
          ...prevState.missingLogos,
          id,
        ],
      }));
    };
  };

  get currentQuote() {
    return this.state.visibleQuotes.find(item => item.id === this.state.current);
  }


  get currentRating() {
    if (this.currentQuote.rating === 0) {
      return null;
    }
    return this.currentQuote.rating;
  }


  render() {
    const { current, missingLogos } = this.state;
    if (!this.currentQuote) {
      return null;
    }

    return (
      <div className="product-quotes">
        <div className={`${this.state.transition ? 'transitioning' : ''} animated-container container`}>
          <div className={`carousel-tabs ${this.state.visibleQuotes.length > 2 ? 'dynamic-order' : ''}`}>
            <div className="square">
            </div>
            <div className={`carousel-tab-container`}>
              {this.state.visibleQuotes.map((quote, i) => {
                return (
                  <div
                    key={quote.id}
                    className={`tab ${quote.id === current ? 'current' : ''} `}
                  >
                    <div onClick={this.setVisibleQuotes(quote.id)}>
                      {<img
                        className={`author-logo ${missingLogos.includes(quote.id) ? 'hidden' : ''}`}
                        alt={quote.author}
                        src={quote.logo}
                        onError={this.handleMissingLogo(quote.id)}
                      />}
                      {missingLogos.includes(quote.id) && <span className="fake-author-logo">{quote.author}</span>}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          <div className="quotes-carousel">
            <div>
              <Swipeable
                onSwipedLeft={this.swipeTo(this.indexes.nextIndex)}
                onSwipedRight={this.swipeTo(this.indexes.previousIndex)}
              >
                <div className="quotes-content">
                  <div className="quotes-item">
                    <div className="quotes-text">
                      {this.quotes.length > 1 &&
                       <>
                         <span onClick={this.swipeTo(this.indexes.previousIndex)} className="slide-nav prev">
                           <Icon
                             name="ico-arrow-left"
                           />
                         </span>
                         <span onClick={this.swipeTo(this.indexes.nextIndex)}
                           className="slide-nav next">
                           <Icon
                             name="ico-arrow-right"
                           />
                         </span>
                       </>
                      }
                      <p dangerouslySetInnerHTML={{ __html: this.currentQuote.description }}/>
                    </div>
                    <div className={'rating-details'}>
                      {this.currentRating &&
                       <Rating
                         rating={this.currentRating}
                         size={'large'}/>
                      }
                      {this.currentRating && <span className="spacer">|</span>}
                      <span className="fake-author-logo">{this.currentQuote.author}</span>
                    </div>
                  </div>
                </div>
              </Swipeable>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

// proptypes
ProductQuotes.propTypes = {
  /**
   * The array of quotes
   */
  quotes: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       * The content of the quote
       */
      description: PropTypes.string,
      /**
       * The author of the quote
       */
      author: PropTypes.string,
      /**
       * The rating of the quote / review
       */
      rating: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
      ]),
    })
  ),
};

export default ProductQuotes;
